import { render } from "./AccountsEdit.vue?vue&type=template&id=a6bc3f10&scoped=true"
import script from "./AccountsEdit.vue?vue&type=script&lang=js"
export * from "./AccountsEdit.vue?vue&type=script&lang=js"

import "./AccountsEdit.vue?vue&type=style&index=0&id=a6bc3f10&lang=scss&scoped=true"

import exportComponent from "/home/mtp/ila.amt.genova.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6bc3f10"]])

export default __exports__